import React from "react";
import { useTranslation } from "next-i18next";
import PropTypes from "prop-types";

import { getBookCover } from "@/shared/utils/url/url";
import { BookActions } from "../..";

import styles from "./para-list.module.scss";

const getTranslationByKeys = ({ t, i18n }, ...keys) => {
  for (let index = 0; index < keys.length; index++) {
    const key = keys[index];
    if (i18n.exists(key)) {
      return t(key);
    }
  }

  return "";
};

function BookInfoInReader({ book, offsetTop }) {
  const i18n = useTranslation();
  const id = book.book_id;
  const bookDescTranslation = getTranslationByKeys(i18n, `books:info${id}`, `books:desc${id}`);
  const bookDesc = bookDescTranslation || book?.description || "";

  return (
    <div
      style={{
        marginTop: offsetTop,
      }}>
      <img
        src={getBookCover(book, true)}
        style={{ float: "left", paddingRight: "0.5rem", maxWidth: "100%", marginBottom: "2rem" }}
      />
      <div>
        <div className={styles["info-bookDesc"]}>
          <h2>{book.title}</h2>
          {book.author.length > 0 && (
            <div className={"bookInfoAuthor " + book.realType}>{`By ${book.author}`}</div>
          )}

          <p
            className="bookInfoDescription"
            dangerouslySetInnerHTML={{ __html: book.description }}
          />
          {book.code && (
            <p className="bookInfoSmallMargin book-code">{`${i18n.t("book_code")}: ${
              book.code
            }`}</p>
          )}
          {book.publisher && (
            <p className="bookInfoBigMargin">
              {i18n.t("publishedBy", { publisher: "" })}
              <span dangerouslySetInnerHTML={{ __html: book.publisher }} />
            </p>
          )}
          {book.isbn && <p className="bookInfoSmallMargin">{`ISBN: ${book.isbn}`}</p>}
          {book.cite && (
            <p className="bookInfoBigMargin">
              {i18n.t("citation", { cite: "" })}
              <span dangerouslySetInnerHTML={{ __html: book.cite }} />
            </p>
          )}
          {bookDesc && (
            <div
              className={styles["book-info"]}
              dangerouslySetInnerHTML={{
                __html: bookDesc,
              }}
            />
          )}
        </div>

        <div className={styles["info-buttons"]}>
          <BookActions isLanding book={book} isBookInfoActions />
        </div>
      </div>
    </div>
  );
}

BookInfoInReader.propTypes = {
  book: PropTypes.object,
  offsetTop: PropTypes.any,
};

export default BookInfoInReader;
